import { DatasetStringValueMapperDTO } from "components/dashboard/charts/interfaces";
import { DatasetMappersApi } from "../DatasetMappersApi";
import {
  defaultMutationOptions,
  defaultResponseHandler,
  QueryKey,
  useQueryWrapper,
} from "./api-hooks-common";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";


export const useGetGeneratedDatasetMapperData = () =>
  useQueryWrapper([QueryKey.DATASET_CATEGORIES], () =>
    DatasetMappersApi.getAll()
  );


  export const useGetDatasetMapperData = (id: string) => {
    const { data: allMappers, isLoading: allMappersLoading } = useGetGeneratedDatasetMapperData();  
    useQuery({
      queryKey: [QueryKey.DATASET_MAPPERS, id],
      queryFn: async () => {
        const response = await fetch(`api/dataset-mappers/${id}`);
        if (!response.ok) {
          throw new Error("Failed to fetch mapper data");
        }
        return response.json();
      },
      initialData: () => {
        if (allMappersLoading) return undefined;
        return allMappers.find((mapper: DatasetStringValueMapperDTO) => mapper.id === id);
      },
    });
  };
  

export const useCreateDatasetMapperData = () => {
  const options = { ...defaultMutationOptions };
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: DatasetStringValueMapperDTO) => {
      return DatasetMappersApi.create(data).then(defaultResponseHandler);
    },
    onError: (error) => {
      options.onFailure!!(error);
    },
    onMutate: (variables) => {
      options.onMutate!!(variables);
    },
    onSuccess: (data: DatasetStringValueMapperDTO | undefined) => {
      queryClient.setQueryData([QueryKey.DATASET_MAPPERS], () => {
        return data;
      });
      options.onSuccess!!();
    },
  });
};

export const useUpdateDatasetMapperData = () => {
  const options = { ...defaultMutationOptions };
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: DatasetStringValueMapperDTO) => {
      return DatasetMappersApi.update(data.id, data).then(
        defaultResponseHandler
      );
    },
    onError: (error) => {
      options.onFailure!!(error);
    },
    onMutate: (variables) => {
      options.onMutate!!(variables);
    },
    onSuccess: (data: DatasetStringValueMapperDTO) => {
      queryClient.setQueryData([QueryKey.DATASET_MAPPERS], () => {
        return data;
      });
      options.onSuccess!!(data);
    },
  });
};

export const useDeleteDatasetMapperData = () => {
  const options = { ...defaultMutationOptions };
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: DatasetStringValueMapperDTO) => {
      return DatasetMappersApi.remove(data.id).then(defaultResponseHandler);
    },
    onError: (error) => {
      options.onFailure!!(error);
    },
    onMutate: (variables) => {
      options.onMutate!!(variables);
    },
    onSuccess: (data: DatasetStringValueMapperDTO | undefined) => {
      queryClient.setQueryData([QueryKey.DATASET_MAPPERS], () => {
        return data;
      });
      options.onSuccess!!(data);
    },
  });
};
